import React from 'react'

const PartySelectField = props => {
	const {
		configData,
		restaurantKey,
		reservationParty,
		handleReservationParty
	} = props

	const hotelLabels = configData.hotel.labels[0]

	// Initialize default values for rendering time options
	let selectOptions = [],
		availableParty = [],
		partyMinimum = 1,
		partyMaximum = 20

	// Set time based on ENV variables
	if (process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_GUESTS_MINIMUM) {
		partyMinimum = process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_GUESTS_MINIMUM
	}
	if (process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_GUESTS_MAXIMUM) {
		partyMaximum = process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_GUESTS_MAXIMUM
	}

	// Construct party values based on property config start time
	while (partyMinimum <= partyMaximum) {
		availableParty.push(partyMinimum)
		partyMinimum++
	}

	for (let party in availableParty) {
		const currentParty = availableParty[party]

		selectOptions.push(
			<option
				key={currentParty}
				value={currentParty}
			>
				{ currentParty }
			</option>
		)
	}

	return (
		<div className="u-form-col">
			<label
				className="u-form-label"
				id={ 'restaurantPartyLabel-' + restaurantKey }
				htmlFor={ 'restaurantParty-' + restaurantKey }
			>
				{ hotelLabels && hotelLabels.party ? hotelLabels.party : 'Party' }
			</label>

			<select
				name={ 'restaurantParty-' + restaurantKey }
				className='u-form-select'
				onChange={ (e) => handleReservationParty(e.target.value) }
				value={ reservationParty}
				aria-labelledby={ 'restaurantPartyLabel-' + restaurantKey }
			>
				<option value="0" disabled>{ hotelLabels && hotelLabels.party ? hotelLabels.party : 'Select Party' }</option>
				{ selectOptions }
			</select>
		</div>
	)
}

export default PartySelectField



// WEBPACK FOOTER //
// ./src/components/forms/restaurantForm/elements/PartySelectField.js